<template>
  <div class="searchView">
    <div class="search_box">
      <el-input
        class="search_input"
        placeholder="请输入关键字进行搜索"
        v-model="keyword"
      ></el-input>
      <span class="search_btn">搜索</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "searchView",
  data() {
    return {
      keyword: ""
    };
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {},
  props: {},
  watch: {},
  components: {}
};
</script>
<style lang="scss">
@import "@/styles/color.scss";
.searchView {
  width: 100%;
  height: 80px;
  background: #fff;
  display: flex;
  align-items: center;
  .search_box {
    width: 960px;
    margin: 0 auto;
    display: flex;
    .search_input {
      .el-input__inner {
        height: 40px;
        line-height: 40px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .search_btn {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: $themeColor;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/SearchView.vue